<div class="flex flex-col h-full w-full">
    <ng-container [ngSwitch]="currentStep">
      <app-email-step 
        *ngSwitchCase="'email'"
         (navigateToPassconsent)="goToPassconsent($event)"
        (next)="goTo('registration', $event)">
      </app-email-step>
      <app-registration-step 
        *ngSwitchCase="'registration'"
        [email]="userEmail" 
        (next)="goTo('terms')" 
        (back)="goTo('email')"
        (navigate)="goTo($event)"
      ></app-registration-step>
      <app-terms-step 
        class="overflow-hidden" 
        *ngSwitchCase="'terms'" 
        (back)="goBack()">
      </app-terms-step>
      <app-user_privacy-step 
        class="overflow-hidden" 
        *ngSwitchCase="'privacy'" 
        (back)="goBack()">
      </app-user_privacy-step>
      <app-passconsent-missing  
        *ngSwitchCase="'passconsent'"
        [email]="userEmail"
        [veevaInfo]="userVeevaInfo" 
        (navigate)="goTo($event)">
      </app-passconsent-missing>
    </ng-container> 
</div>